import {
  ListItemButtonText,
  ListItemIcon,
  TranslateButtonContainer,
  TranslateButtonItem,
} from './styles';
import { Language } from '@mui/icons-material';
import { Text } from '@/components/atoms/text';
import { Menu, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, MouseEvent, useContext } from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import { Desktop } from '../viewport/desktop';
import { Mobile } from '../viewport/mobile';
import { SidebarAndModalContext } from '@/context/sidebarAndModal';

export const languages = {
  'pt-BR': {
    label: 'Português',
    alt: 'Portuguese',
  },
  'en-US': {
    label: 'English',
    alt: 'English',
  },
};

interface TranslateButtonProps {
  onChangeLanguage?: () => void;
}

export const TranslateButton = ({ onChangeLanguage }: TranslateButtonProps) => {
  const theme = useTheme();

  const { currentLanguage, setLanguage } = useLanguage();
  const { handleDrawerClose } = useContext(SidebarAndModalContext);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    handleDrawerClose();
  };

  const handleLanguageChange = (newLanguage: 'pt-BR' | 'en-US') => {
    if (newLanguage === currentLanguage) return;

    setLanguage(newLanguage);
    onChangeLanguage?.();
  };

  return (
    <>
      <Mobile>
        <TranslateButtonItem
          onClick={() => {
            onChangeLanguage?.();
          }}
        >
          <Language sx={{ color: theme.palette.action.active }} />
          <Text>{languages[currentLanguage].label}</Text>
        </TranslateButtonItem>
      </Mobile>

      <Desktop>
        <TranslateButtonContainer onClick={handleClick}>
          <ListItemIcon>
            <Language sx={{ color: theme.palette.action.active }} />
          </ListItemIcon>

          <ListItemButtonText>
            <Text variant="subtitle2" color="text.primary">
              {languages[currentLanguage].label}
            </Text>
          </ListItemButtonText>
        </TranslateButtonContainer>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {Object.entries(languages).map(([key, value]) => {
            if (key === currentLanguage) return null;
            return (
              <MenuItem
                sx={{
                  minWidth: '220px',
                  gap: theme.spacing(2),
                }}
                key={key}
                onClick={() => {
                  handleLanguageChange(key as 'pt-BR' | 'en-US');
                  handleClose();
                }}
              >
                <Language sx={{ color: theme.palette.action.active }} />
                <Text>{value.label}</Text>
              </MenuItem>
            );
          })}
        </Menu>
      </Desktop>
    </>
  );
};
